import React from 'react';
import '../homeDashboard/DashboardSkeleton.css';

const Line = ({ width = '100%', height = 14 }) => <span className="dashboard-skeleton app-reviews-shimmer-line" style={{ width, height }} />;

export default function AppReviewsShimmer({ more = false }) {
  const rows = <div className="app-reviews-list">{Array.from({ length: more ? 2 : 4 }, (_, index) => <div className="app-reviews-item" key={index}>
    <div className="app-reviews-rating"><Line width={36} height={24} /><Line width={120} height={18} /></div>
    <Line /><Line width="75%" />
    <div className="app-reviews-user"><span className="dashboard-skeleton app-reviews-avatar" /><Line width={130} /></div>
  </div>)}</div>;
  return <div role="status" aria-label={more ? 'Loading more reviews' : 'Loading reviews'} aria-busy="true" className="app-reviews-shimmer">
    <div aria-hidden="true" className={more ? 'app-reviews-shimmer-more' : 'app-reviews-grid'}>
      {!more && <div className="app-reviews-summary"><Line width="70%" height={20} /><Line width={90} height={62} /><Line width={130} height={20} /><Line /><Line width="80%" /><Line height={46} /></div>}
      {rows}
    </div>
  </div>;
}
